module.exports = __webpack_public_path__ + "static/media/list.b42f1e03.svg";